import { Link } from 'react-router-dom';

interface HotArticle {
  slug: string;
  title: string;
  categoryName: string;
  publishDate: string;
  author: string;
  readCount: number;
  imageUrl: string;
}

const hotArticles: HotArticle[] = [
  {
    slug: 'douyin-wanghong-baoliao-20260701',
    title: '某千万粉丝抖音网红被前助理爆出私生活混乱，聊天记录曝光引发全网热议',
    categoryName: '网红爆料',
    publishDate: '2026-07-06',
    author: '吃瓜小编',
    readCount: 1285000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20breaking%20news%20illustration%20with%20a%20silhouetted%20figure%20against%20a%20warm%20red%20gradient%20background%2C%20abstract%20social%20media%20icons%20floating%2C%20editorial%20journalism%20style%20with%20striking%20contrast%2C%20warm%20amber%20and%20crimson%20tones%2C%20clean%20composition&width=500&height=600&seq=hot-grid-01&orientation=portrait',
  },
  {
    slug: 'zhibo-quan-jingbao-20260704',
    title: '直播圈大地震！多位头部主播涉嫌偷税漏税被约谈，涉及金额或超十亿',
    categoryName: '热门追踪',
    publishDate: '2026-07-04',
    author: '深度调查',
    readCount: 2150000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20business%20investigation%20scene%20with%20abstract%20financial%20data%20visualization%20in%20dark%20red%20and%20amber%20tones%2C%20modern%20office%20setting%20with%20serious%20atmosphere%2C%20papers%20scattered%2C%20editorial%20financial%20journalism%20style&width=500&height=600&seq=hot-grid-02&orientation=portrait',
  },
  {
    slug: 'shipinhao-fensi-jingji-20260702',
    title: '视频号大V被曝虚假人设，300万粉丝集体要求退款，平台紧急介入',
    categoryName: '网红爆料',
    publishDate: '2026-07-03',
    author: '真相挖掘机',
    readCount: 873000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20exposure%20scene%20with%20a%20cracked%20mask%20revealing%20truth%20beneath%2C%20warm%20amber%20and%20crimson%20lighting%2C%20abstract%20digital%20social%20media%20elements%20dissolving%2C%20investigative%20journalism%20aesthetic&width=500&height=600&seq=hot-grid-03&orientation=portrait',
  },
  {
    slug: 'yule-quan-zuixin-gua-20260706',
    title: '某顶流男团成员被曝私下与多名女粉丝保持不当关系，团队紧急发声明否认',
    categoryName: '明星黑料',
    publishDate: '2026-07-02',
    author: '娱乐深喉',
    readCount: 1680000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Intense%20entertainment%20industry%20scandal%20atmosphere%20with%20abstract%20stage%20lights%20in%20deep%20crimson%20and%20amber%2C%20silhouetted%20figure%20on%20a%20dark%20stage%2C%20dramatic%20theatrical%20lighting%2C%20mysterious%20composition&width=500&height=600&seq=hot-grid-04&orientation=portrait',
  },
  {
    slug: 'kuaishou-daihuo-fanju-20260705',
    title: '快手带货一姐带货翻车，所售"纯天然"护肤品被检测出含有激素成分',
    categoryName: '热门追踪',
    publishDate: '2026-07-01',
    author: '产品侦探',
    readCount: 1890000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Product%20safety%20investigation%20scene%20with%20laboratory%20glassware%20and%20cosmetics%20in%20warm%20amber%20lighting%2C%20abstract%20danger%20warning%20elements%20in%20red%2C%20scientific%20testing%20atmosphere%2C%20editorial%20style&width=500&height=600&seq=hot-grid-05&orientation=portrait',
  },
  {
    slug: 'xiaohongshu-bo-zhu-fanshui-20260707',
    title: '小红书多名美妆博主被曝收钱发虚假测评，品牌方内部邮件意外流出',
    categoryName: '网红爆料',
    publishDate: '2026-06-30',
    author: '行业观察家',
    readCount: 765000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Beauty%20industry%20expose%20scene%20with%20scattered%20cosmetics%20and%20leaked%20documents%20on%20a%20desk%2C%20warm%20amber%20and%20rose%20gold%20tones%2C%20dramatic%20side%20lighting%2C%20editorial%20investigative%20journalism&width=500&height=600&seq=hot-grid-06&orientation=portrait',
  },
  {
    slug: 'bilibili-upzhu-tuiquan-20260708',
    title: 'B站百万UP主突然宣布退圈，长文揭露MCN机构霸王条款内幕',
    categoryName: '热门追踪',
    publishDate: '2026-06-29',
    author: '创作生态观察',
    readCount: 1120000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Emotional%20farewell%20scene%20with%20a%20creator%20packing%20up%20equipment%20in%20a%20dim%20studio%2C%20warm%20golden%20hour%20light%20streaming%20through%20blinds%2C%20bittersweet%20atmosphere%2C%20documentary%20style&width=500&height=600&seq=hot-grid-07&orientation=portrait',
  },
  {
    slug: 'zhiming-nvxing-heidong-20260703',
    title: '知名女星被拍到深夜密会神秘男子，酒店同进同出引爆恋情猜测',
    categoryName: '明星黑料',
    publishDate: '2026-07-05',
    author: '八卦雷达',
    readCount: 956000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20nighttime%20paparazzi%20style%20scene%20with%20warm%20city%20lights%20blurred%20in%20background%2C%20two%20silhouettes%20near%20a%20luxury%20hotel%20entrance%2C%20dramatic%20golden%20lighting%2C%20cinematic%20mood&width=500&height=600&seq=hot-grid-08&orientation=portrait',
  },
];

const cardColors = [
  'bg-primary-100/70',
  'bg-accent-100/70',
  'bg-secondary-100/70',
  'bg-primary-50',
];

export default function HotTopicsGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="mb-10">
          <p className="text-xs font-medium text-foreground-500 font-heading tracking-wider uppercase mb-2">
            热点追踪
          </p>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
              全网<span className="font-heading italic text-primary-600">最热</span>吃瓜
            </h2>
            <Link
              to="/category/remen-zhuizong"
              className="whitespace-nowrap text-sm text-primary-600 hover:text-primary-700 font-medium inline-flex items-center gap-1 transition-colors"
            >
              查看全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {hotArticles.map((article, index) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className={`group rounded-2xl overflow-hidden ${cardColors[index % 4]} transition-all duration-300 hover:scale-[1.02] cursor-pointer`}
            >
              <div className="aspect-[4/5] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-[10px] px-2 py-0.5 rounded-full bg-secondary-200/80 text-secondary-800 font-medium">
                    {article.categoryName}
                  </span>
                  <span className="text-[10px] text-foreground-500">{article.publishDate}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <div className="flex items-center gap-3 mt-3">
                  <span className="text-[10px] text-foreground-500">{article.author}</span>
                  <span className="text-[10px] text-foreground-400 flex items-center gap-0.5">
                    <i className="ri-eye-line"></i>
                    {article.readCount > 10000
                      ? `${(article.readCount / 10000).toFixed(1)}万`
                      : article.readCount}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}